import type { DeliveryGroupDraft, DeliveryGroupStopDraft } from './deliveryGroupTypes';
import type { ExecutionLockRouteContext } from './executionTopologyLock';

export function flattenGroupStops(groups: DeliveryGroupDraft[]): DeliveryGroupStopDraft[] {
  const out: DeliveryGroupStopDraft[] = [];
  for (const group of groups) {
    out.push(...group.loadingStops, ...group.unloadingStops);
  }
  return out;
}

export function buildExecutionLockContext(params: {
  routeStatus?: string | null;
  inTransit?: boolean;
  activeExecutionStopId?: number | null;
  activeExecutionStopUid?: string | null;
}): ExecutionLockRouteContext {
  return {
    routeStatus: params.routeStatus ?? null,
    inTransit: params.inTransit,
    activeExecutionStopId: params.activeExecutionStopId ?? null,
    activeExecutionStopUid: params.activeExecutionStopUid ?? null
  };
}
